import styles from './Footer.module.css'
import { useNavigate } from 'react-router-dom'
import { useLanguage } from '@context/LanguageContext'
import { Facebook, Twitter, Instagram, Linkedin } from '../interface/Icons'

export default function Footer () {
  const { t, lang } = useLanguage()
  const navigate = useNavigate()

  const handleNavigation = (page) => {
    navigate(`/${lang}/${page}`)
  }

  const handleSocialClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <footer className={styles.footer}>
      <nav className={styles.navigation} aria-label={t.core.access.footer.navigation}>
        <button
          onClick={() => handleNavigation('about')}
          className={styles.navLink}
          aria-label={t.core.access.navigation.about}
        >
          {t.core.navigation.about}
        </button>

        <button
          onClick={() => handleNavigation('privacy')}
          className={styles.navLink}
          aria-label={t.core.access.navigation.privacy}
        >
          {t.core.navigation.privacy}
        </button>

        <button
          onClick={() => handleNavigation('terms')}
          className={styles.navLink}
          aria-label={t.core.access.navigation.terms}
        >
          {t.core.navigation.terms}
        </button>

        <button
          onClick={() => handleNavigation('contact')}
          className={styles.navLink}
          aria-label={t.core.access.navigation.contact}
        >
          {t.core.navigation.contact}
        </button>
      </nav>

      <small className={styles.copyright}>
        {t.core.footer.copyright}
      </small>

      <nav className={styles.social} aria-label={t.core.access.footer.social}>
        <button
          onClick={() => handleSocialClick('https://www.linkedin.com/showcase/memodiez')}
          className={styles.socialLink}
          aria-label={t.core.access.social.linkedin}
          title={t.core.access.social.linkedin}
        >
          <Linkedin size={30} stroke={1.5} aria-hidden='true' />
        </button>

        <button
          onClick={() => handleSocialClick('https://facebook.com/memodiez10')}
          className={styles.socialLink}
          aria-label={t.core.access.social.facebook}
          title={t.core.access.social.facebook}
        >
          <Facebook size={30} stroke={1.5} aria-hidden='true' />
        </button>

        <button
          onClick={() => handleSocialClick('https://twitter.com/memodiez_10')}
          className={styles.socialLink}
          aria-label={t.core.access.social.twitter}
          title={t.core.access.social.twitter}
        >
          <Twitter size={30} stroke={1.5} aria-hidden='true' />
        </button>

        <button
          onClick={() => handleSocialClick('https://instagram.com/memodiez10')}
          className={styles.socialLink}
          aria-label={t.core.access.social.instagram}
          title={t.core.access.social.instagram}
        >
          <Instagram size={30} stroke={1.5} aria-hidden='true' />
        </button>
      </nav>
    </footer>
  )
}
